import { Box, Grid, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { PageFilterSection } from 'src/shared/components/organisms/pageFilterSection';
import SearchField from 'src/shared/components/form/searchField';
import { useEffect, useMemo, useState } from 'react';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { useLocalStorage } from 'src/shared/hooks/useLocalStorage';
import { LocalStorageKeys } from 'src/shared/models/enums/localStorageKeys.enum';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'src/shared/models/enums/gridFilterConfig';
import { MemberStripeCustomerSearchFilter } from '../models/memberStripeCustomerSearchFilter';
import { StripeTabNavigation } from './stripeTabNavigation';
import { MemberStripeCustomerDataGrid } from '../components/memberStripeCustomerDataGrid';

// Medgivanden
export const MemberStripeCustomersOverviewPage = () => {
  const { t } = useTranslation();

  const isMounted = useIsMounted();

  const [tempSearchString, setTempSearchString] = useState<string | undefined>(undefined);
  const [searchInitialized, setSearchInitialized] = useState<boolean>(false);

  const [memberStripeCustomerFilter, setMemberStripeCustomerFilter] = useLocalStorage(LocalStorageKeys.MemberStripeCustomerFilter, {
    sortCol: 'createdAt',
    sortDir: 'desc',
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
  } as MemberStripeCustomerSearchFilter);

  const searchFilter: MemberStripeCustomerSearchFilter = useMemo(() => {
    return {
      filter: memberStripeCustomerFilter?.filter,
      pageSize: memberStripeCustomerFilter?.pageSize,
      pageIndex: memberStripeCustomerFilter?.pageIndex,
      sortCol: memberStripeCustomerFilter?.sortCol,
      sortDir: memberStripeCustomerFilter?.sortDir,
    } as MemberStripeCustomerSearchFilter;
  }, [
    memberStripeCustomerFilter?.filter,
    memberStripeCustomerFilter?.pageIndex,
    memberStripeCustomerFilter?.pageSize,
    memberStripeCustomerFilter?.sortCol,
    memberStripeCustomerFilter?.sortDir,
  ]);

  useEffect(() => {
    if (isMounted() && searchInitialized) {
      if (tempSearchString === '') {
        setMemberStripeCustomerFilter((prev) => ({ ...prev, ...{ filter: '', pageIndex: 0 } }));
      }
      if (tempSearchString && tempSearchString.length >= 2) {
        setMemberStripeCustomerFilter((prev) => ({ ...prev, ...{ filter: tempSearchString, pageIndex: 0 } }));
      } else {
        setMemberStripeCustomerFilter((prev) => ({ ...prev, ...{ filter: '', pageIndex: 0 } }));
      }
    }
  }, [isMounted, searchInitialized, setMemberStripeCustomerFilter, tempSearchString]);

  return (
    <GridWrapper>
      <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
        <MainContentHeader title={t('invoice:stripeStatus.header')} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <StripeTabNavigation />
          <PageFilterSection
            leftContent={
              <SearchField
                initialValue={searchFilter.filter || ''}
                onSearch={(newSearchString) => {
                  setSearchInitialized(true);
                  setTempSearchString(newSearchString);
                }}
              />
            }
          />
          <Box className='section-inset'>
            <MemberStripeCustomerDataGrid
              searchFilter={searchFilter}
              searchFilterCallback={(newFilter) =>
                setMemberStripeCustomerFilter((prev) => ({
                  ...prev,
                  ...newFilter,
                }))
              }
            />
          </Box>
        </Paper>
      </Grid>
    </GridWrapper>
  );
};
